<template>
  <div id="app" style="position: relative">
    <div style="position: absolute; top: 0; opacity: 0">
      <img src="/static/img/achuanqi.png" alt />
    </div>
    <router-view
      v-if="
        path != '/sw' &&
        path != '/bd' &&
        path != '/baidu' &&
        path != '/bdAboutUs' &&
        path != '/bdproductInfo' &&
        path != '/bdpermit' &&
        path != '/bdsoftwareLis' &&
        path != '/bdprivacy'
      "
      :style="{ minHeight: Height + 'px' }"
      style="margin: 0"
    />
    <router-view v-else />
    <!-- <app-footer v-show="!(path === '/client' || path === '/phone' || path === '/teamwork' || path === '/myGame/gameDetail')"></app-footer> -->
    <!-- <app-footer v-show="!(path == '/' || path == '/home/index' || path == '/aboutUs' || path == '/permit' || path == '/softwareLis' || path == '/privacy' || path == '/contactUs')"></app-footer> -->
    <app-footer
      v-if="
        path != '/sw' &&
        path != '/bd' &&
        path != '/baidu' &&
        path != '/bdAboutUs' &&
        path != '/bdproductInfo' &&
        path != '/bdpermit' &&
        path != '/bdsoftwareLis' &&
        path != '/bdprivacy' &&
        path != '/360m' &&
        path != '/msougou' &&
        path != '/wm' &&
        path != '/zdzm' &&
        path != '/uc'
      "
    ></app-footer>
  </div>
</template>
<script>
import AppFooter from "./components/footer.vue";
import { getGameLink, getQQKey, getDownUrl } from "@/req/homes";
export default {
  data() {
    return {
      path: "",
      paths: "",
      Height: 0,
      modelShow: false,
    };
  },
  created() {
    if (this.isMobile()) {
      // location.href = "http://wap.996box.com";
      if (
        window.location.pathname != "/bd" &&
        window.location.pathname != "/baidu" &&
        window.location.pathname != "/pzProductInfo" &&
        window.location.pathname != "/pzPermit" &&
        window.location.pathname != "/pzSoftwareLis" &&
        window.location.pathname != "/pzPrivacy" &&
        window.location.pathname != "/pzAuthorization" &&
        window.location.pathname != "/360m" &&
        window.location.pathname != "/msougou" &&
        window.location.pathname != "/wm" &&
        window.location.pathname != "/zdzm" &&
        window.location.pathname != "/uc"
      ) {
        const channelCode = this.getUrlKey("id");
        if (channelCode && !this.checknumber(channelCode)) {
          location.href =
            "https://m.996box.com/channelPackage.html" +
            "?" +
            location.href.split("?")[1];
        } else {
          location.href = "http://m.996box.com/";
        }
      }
    } else {
      this.modelShow = true;
    }
    this.getDownList();
    this.getQQKeys();
  },
  mounted() {
    this.isIE();
    // 对比当前path
    this.path = this.$route.path;
    // 动态获取当前高度-header+footer的宽度让footer始终居底
    this.Height = document.documentElement.clientHeight;
    if (this.path == "/gameDetail") {
      this.Height = this.Height + 30;
    }
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight;
    };
  },
  components: {
    AppFooter,
  },
  methods: {
    isIE() {
      // if (window.navigator.userAgent.indexOf("MSIE") >= 1) {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        window.location.href = "http://land.996box.com/downloadPage/ie.html";
        // alert(1)
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    async getDownList() {
      const res = await getGameLink();
      this.$store.state.home.downList = res;
    },
    async getQQKeys() {
      const res = await getQQKey();
      if (res.code == 200) {
        this.$store.state.home.downImgList = res.data;
      }
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    checknumber(channelCode) {
      const reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(channelCode)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: "Microsoft YaHei";
  overflow-y: hidden;
  // min-width: 1200px;
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   top: 0;
  //   bottom: 0;
  //  :style="{minHeight: height+'px'}"
  // console.log(document.documentElement.clientHeight)
}
// ::-webkit-scrollbar {
//   display: none; /* Chrome Safari */
// }
#cnzz_stat_icon_1279745428 {
  opacity: 0;
  position: absolute;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>
